import React from 'react'
import { motion } from "framer-motion";
import GppGoodIcon from '@mui/icons-material/GppGood';
import GavelIcon from '@mui/icons-material/Gavel';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

export default function Compliance() {
     const cards = [
    {
      icon: <GavelIcon className="w-8 h-8 text-cyan-300" />,
      role: "Legal Officer",
      name: "V.K. Gupta",
      email: "grievance@b4salary.com",
      phone: "+91 7733866660",
    },
    {
      icon: <GppGoodIcon className="w-8 h-8 text-cyan-300" />,
      role: "Collection Officer",
      name: "Naveen Kakran",
      email: "collection@b4salary.com",
      phone: "+91 7733866664",
    },
  ];
  return (
    <section className="w-full bg-[#0f2e4d] py-16 px-4 sm:px-6 lg:px-8 text-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">

        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl sm:text-3xl font-bold mb-4">
            Compliance & Redressal
          </h2>
          <p className="text-gray-300 leading-7">
            B4Salary is committed to maintaining transparent practices and structured grievance handling processes designed to support customer trust, accountability, and regulatory compliance.
          </p>
        </motion.div>

        {/* RIGHT CARDS */}
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">

          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="border border-white/20 rounded-2xl p-6 backdrop-blur-md bg-white/5 hover:bg-white/10 transition-all duration-300"
            >
              {/* Icon */}
              <div className="mb-4">{card.icon}</div>

              {/* Role */}
              <p className="text-gray-300 text-sm mb-1">{card.role}</p>

              {/* Name */}
              <h3 className="text-lg font-semibold mb-4">{card.name}</h3>

              {/* Contact */}
              <div className="space-y-2 text-sm text-gray-300">
                <div className="flex items-center gap-2"> 
                  <EmailIcon className="w-4 h-4" />
                  <span>{card.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <LocalPhoneIcon className="w-4 h-4" />
                  <span>{card.phone}</span>
                </div>
              </div>
            </motion.div>
          ))}

        </div>
      </div>
    </section>
  )
}
